<style scoped>
/* PC端样式 */
.about {
  background-color: #000;
  padding-top: 150px;

}

.about-2-title {
  color: #fcd199;
  font-size: 3.5rem;
  text-align: center;
  margin-top: 50px;
}

.about-2-content {
  color: #fcd199;
  font-size: 1.2rem;
  margin: auto;
  margin-top: 70px;
  width: 70%;
  text-indent: 2em;


}

.about-3-content {
  color: #fcd199;
  font-size: 1.2rem;
  margin: auto;
  width: 50%;
  margin-top: 10px;
}

.about-2 {
  margin-top: 30px;
}

.about-1-image {
  width: 100%;
  height: 100%;

}

.brand-item {
  width: 600px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.brand-item-title {
  font-size: 1.5rem;
  width: 600px;
  height: 120px;
  color: #000;
  line-height: 120px;
  background-color: white;
  text-align: center;
  border-radius: 0 0 20px 20px;
}

.brand-item-image {
  width: 600px;
  height: 100%;

}

.brand-content {
  display: flex;
  max-width: 1250px;
  margin: auto;
  justify-content: space-between;
  flex-wrap: wrap;


}

.brand-item-bg {
  width: 100%;
}
</style>

<style scoped>
@media (max-width: 768px) {
  /* 手机端样式 */
  .about {
    padding-top: 60px;
  }
  .about-2-title {
    font-size: 1.2rem;
    margin-top: 30px;
  }
  .about-2-content {
    font-size: 1rem;
    margin-top: 30px;
    width: 90%;
    text-indent: 1.5em;
  }
  .about-3-content {
    font-size: 1rem;
    width: 90%;
    margin-top: 10px;
  }
  .about-2 {
    margin-top: 20px;
  }
  .about-1-image {
    width: 100vw;
    height: auto;
    max-height: 200px;
    object-fit: cover;
  }
  .brand-item {
    width: 48%;
    max-width: 100%;
    margin-top: 30px;
  }
  .brand-item-title {
    font-size: 0.7rem;
    width: 100vw;
    max-width: 100%;
    height: 60px;
    line-height: 60px;
    border-radius: 0 0 10px 10px;
  }
  .brand-item-image {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  .brand-content {
    max-width: 90%;
    margin: 0;
    align-items: center;
    justify-content: space-between;
    margin: auto;
  }
  .brand-item-bg {
    width: 100vw;
    max-width: 100%;
  }
}
</style>
<template>
  <div class="about">
    <div class="page-header">
    
    </div>
    <div class="about-2">
      <div class="about-2-title">品牌简介</div>
      <div class="about-2-content">
        东阳光鲜虫草，是消费升级趋势与“健康中国”战略背景下，诞生的追求卓越品质的滋补品牌。其专注冬虫夏草行业17年，致力于为广大消费者全年提供更多活性，更加安心的新鲜冬虫夏草，开创了“好虫草鲜着吃”的滋补新体验，引领行业进入冬虫夏草高品质时代。
      </div>

    </div>
    <div class="about-3">
      <div class="about-2-title">战略合作</div>
      <div class="brand-content">
        <div class="brand-item">
 
          <div class="brand-item-title">
            浙江卫视战略合作
          </div>
        </div>
        <div class="brand-item">

          <div class="brand-item-title">
            国家开发银行战略合作
          </div>
        </div>
        <div class="brand-item">
      
          <div class="brand-item-title">
            广东恒健投资战略合作
          </div>
        </div>
        <div class="brand-item">
 
          <div class="brand-item-title">
            京东健康战略合作
          </div>
        </div>
      </div>

    </div>

    <div class="about-3">
      <div class="about-2-title">品牌打造</div>
      <div class="brand-content">
        <div class="brand-item">
    
          <div class="brand-item-title">
            4年独家冠名《天赐的声音》2-5季
          </div>
        </div>
        <div class="brand-item">
     
          <div class="brand-item-title">
            4年赞助综艺《听说很好吃》1-4季
          </div>
        </div>
        <div class="brand-item">
       
          <div class="brand-item-title">
            <p>CBA 2022-2024赛季</p>
          </div>
        </div>
        <div class="brand-item">
   
          <div class="brand-item-title">
            <p>CBA 2024-2025赛季</p>
          </div>
        </div>
        <div class="brand-item">
  
          <div class="brand-item-title">
            独家冠名《嗨放派》第2季
          </div>
        </div>
        <div class="brand-item">
        
          <div class="brand-item-title">
            赞助《王牌对王牌》第8季
          </div>
        </div>
      </div>

    </div>


    <div class="about-3">
      <div class="about-2-title">媒体报道</div>
      <div class="brand-content">
        <div class="brand-item">

          <div class="brand-item-title">
            CCTV发现之旅《阳光下的鲜草》专题报道
          </div>
        </div>
        <div class="brand-item">

          <div class="brand-item-title">
            《人民日报》健康客户端深度专访
          </div>
        </div>
      </div>

    </div>
    <div class="about-3">
      <div class="about-2-title">奖项荣誉</div>
      <div class="about-3-content" style="margin-top: 50px;">
        2019 获第十二届健康中国论坛年度科技创新品牌奖
      </div>
      <div class="about-3-content">
        2020 获2020京东健康滋补品牌创新突破奖
      </div>
      <div class="about-3-content">
        2021 获中医药滋补市场影响力品牌大奖
      </div>
      <div class="about-3-content">
        获老年健康产业合作单位奖杯
      </div>
      <div class="about-3-content">
        2022 获《经济观察报》2022IF·创新领军者“产业创新领军者”奖杯
      </div>
      <div class="about-3-content">
        获浙江广电“Z动力”传播营销大会“2022年度营销卓越奖”、“2022年度十佳广告大客户”
      </div>
      <div class="about-3-content">
        获”我最喜爱的湖北品牌“电视大赛银奖
      </div>
      <div class="about-3-content">
        2023 获博鳌亚洲论坛全球经济发展与安全论坛（GEDS）第二届大会 “合作伙伴”荣誉证书
      </div>
      <div class="about-3-content">
        获第30届中国国际广告节-2023广告主金伙伴盛典-年度整合营销金奖
      </div>
      <div class="about-3-content">
        获京东健康《冬虫夏草品质领先奖》
      </div>
      <div class="about-3-content">
        ...
      </div>


    </div>

    <div class="about-3" style="padding-bottom: 100px;">
      <div class="about-2-title">品质保证</div>
      <div class="about-3-content" style="margin-top: 50px;text-align: center;">
        东阳光集团匠心出品
      </div>
      <div class="about-3-content" style="text-align: center;">
        A+H双主板上市企业
      </div>
      <div class="about-3-content" style="text-align: center;">
        中国民营企业500强*
      </div>
    </div>
  </div>
</template>

<script setup>
// 关于我们页面逻辑
</script>
